import React from "react";
import "../../css/designSystem/Hero.css";
import PrimaryButton from "./buttons/PrimaryButton";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  showContactButton = true,
  children,
}) {
  return (
    <section
      className="hero background-container bg-gray-3"
      // style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="content-container column-center gap-xxxl hero-content-container">
        <div className="column-center gap-m hero-text">
          <p className="subtitle-semibold text-primary-2 uppercase">
            {renderLines(subtitle)}
          </p>
          <h2 className="text-primary-1 uppercase">{renderLines(title)}</h2>
          {/* {title && <div className="divider align-center"></div>} */}
          {children}
          {showContactButton && <PrimaryButton text="Contact Us" />}
        </div>
      </div>
    </section>
  );
}

export default Hero;
